import { Container } from '@mui/material';
import { ReactNode } from 'react';
import PageLoading from 'components/common/PageLoading';

interface PageContentProps {
  children: ReactNode;
  isLoading?: boolean;
}

const PageContent = ({ children, isLoading = false }: PageContentProps) => (
  <Container sx={{ px: { xs: 0, sm: 2 } }}>
    {isLoading ? <PageLoading /> : children}
  </Container>
);

export default PageContent;
